import { PendingBillsModel } from 'one-card-pending-bills';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 *Pending Bills Component
 * @param response has the backend
 * pending bills response
 * @param context has settings etc...
 */


export const TransformResponse = (response: any, context: any) => {

    /**
     * @param result contains the transformed response
     */
    let pendingbills: PendingBillsModel = { totalpendingbills: 0, totalbalance: 0 };

    let result: any = {
        bills: pendingbills,
        error: undefined

    }
    if (response && response.length > 0) {
        let totalinsurebal, totalpatbal
        let totalbills = response?.length
        response.map((ele: any) => {
        totalinsurebal = ele.badDebtAmount ? `${ele.badDebtAmount}` : "";
        totalpatbal = ele.totalAmountDue ? `${ele.totalAmountDue}` : "";
        })
        pendingbills['totalpendingbills'] = totalbills;
        pendingbills['totalbalance'] = totalpatbal;
        pendingbills['insurancebalance'] = totalinsurebal;

    }
    result.bills = pendingbills;
    return result;
}